module.exports = __webpack_public_path__ + "static/media/headerImg.1782e480.jpg";